import React from 'react'
import _ from 'lodash'
import '../../assets/css/pages/calendar/assignment-info-panel.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlus  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import pluralize from 'pluralize'
library.add(faMinus, faPlus)

class AssignmentInfoPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: true,
      isOverflown:{
        status: false,
        text:'',
        offsetTop:0,
        offsetWidth:0,
        offsetHeight:0
      }
    }
  }

  alphabetizeSection(listing) {
    return _.orderBy(listing, student => [
      student.firstName ? student.firstName.toUpperCase() : null,
      student.lastName ? student.lastName.toUpperCase() : null
    ])
  }

  isOverflowing(e){
    // this function is to check if the current element is overflowing
    const ele = e.target
    if(ele.clientWidth < ele.scrollWidth){
      // only return true if element is horizontally overflown
      this.setState(prev=>({
        isOpen:prev.isOpen,
        isOverflown:{
          status:true, 
          text:ele.innerText,
          offsetTop:ele.offsetTop,
          offsetWidth:ele.offsetLeft,
          offsetHeight:ele.offsetHeight
        }
      }))
      return true
    }
    return false
  }

  resetIsOverflow(){
    this.setState(prev=>({
      isOpen:prev.isOpen,
      isOverflown:{
        status:false, 
        text:'',
        offsetTop:0,
        offsetWidth:0,
        offsetHeight:0
      }
    }))
  }

  render() {
    let columnOneSize
    let dataLength
    let courseName
    let assignmentDate
    let panelTitle
    if (this.props.type === 'individual') {
      courseName = this.props.assignmentData[0].courseName
      dataLength = this.props.assignmentData.length
      assignmentDate = this.props.assignmentData[0].assignmentDate
      panelTitle = `${pluralize('Individual', dataLength, true)} Assigned To Queue On ${assignmentDate}`
    } else if (this.props.type === 'class') {
      dataLength = this.props.assignmentData.length
      assignmentDate = this.props.assignmentData[0][0].assignmentDate

      if(this.props.assignmentData[0][0].contentType === 'expedition'){
        //TODO: note that this is not a good implementation, it should be changed such that courseName is actually referencing course name in expedition v2 calendar design at a later point
        courseName = this.props.assignmentData[0][0].sectionName
        panelTitle = `${pluralize('Group', dataLength, true)} in ${courseName} assigned to queue on ${assignmentDate}`
      }
      else{
        courseName = this.props.assignmentData[0][0].courseName
        panelTitle = `${pluralize('Class', dataLength, true)} in ${courseName} Assigned To Queue On ${assignmentDate}`
      }

    } else if (this.props.type === 'self') {
      panelTitle = 'Assigned to Myself'
    }

    let columnOne
    let columnTwo

    return(
      <div className='assignment-info-panel'>
        <div className='panel-header'>
          <p className='panel-title'>{panelTitle}</p>
          {this.props.type !== 'self' &&
            <span className='panel-minimize' onClick={()=> this.setState({ isOpen: !this.state.isOpen })}>
              <FontAwesomeIcon icon={this.state.isOpen ? 'minus': 'plus'}/>
            </span>
          }
        </div>
        {this.state.isOpen &&
          <div className= {'panel-body'}>
            {this.props.type === 'class' && _.map(this.props.assignmentData, section => {
              const isExpedition = section[0].contentType === 'expedition'
              section = this.alphabetizeSection(section)
              columnOneSize = Math.ceil(section.length / 2)
              columnOne = section.slice(0,columnOneSize)
              columnTwo = section.slice(columnOneSize)
              return(
                <div className='class-wrapper panel-section' key={isExpedition? `class-${section[0].sectionName}-group${section[0].groupIndex+1}` :'class-' + section[0].sectionName}>
                  <p className='panel-subtitle'>{isExpedition? `Group ${section[0].groupIndex + 1}`:section[0].sectionName}</p>
                  <div className='panel-contents class-students'>
                    <div className='column-one'>
                      { _.map(columnOne, student =>
                        <div className='student-row' key={'columnOneStudent' + columnOne.indexOf(student)}>
                          <div className='completed-check'>
                            {student.isCompleted &&
                              <FontAwesomeIcon icon='check'/>
                            }
                          </div>
                          <p className='panel-list-item student-name' 
                          onMouseEnter={(e)=> this.isOverflowing(e)}
                          onMouseOut={()=>this.resetIsOverflow()}
                          >
                            {student.fullName? student.fullName: student.firstName + ' ' + (student.lastName ? student.lastName : '') }
                          </p>
                        </div>
                      )}
                      {this.state.isOverflown.status? 
                        <ToolTip 
                        name={this.state.isOverflown.text} 
                        location={{
                          top:this.state.isOverflown.offsetTop, 
                          width:this.state.isOverflown.offsetWidth,
                          height:this.state.isOverflown.offsetHeight
                        }} />: null}
                    </div>
                    <div className='column-two'>
                      {_.map(columnTwo, student =>
                        <div className='student-row' key={'columnTwoStudent' + columnTwo.indexOf(student)}>
                          <div className='completed-check'>
                            {student.isCompleted &&
                              <FontAwesomeIcon icon='check'/>
                            }
                          </div>
                          <p className='panel-list-item student-name' 
                          onMouseEnter={(e)=> this.isOverflowing(e)}
                          onMouseOut={()=>this.resetIsOverflow()}
                          >
                            {student.fullName? student.fullName: student.firstName + ' ' + (student.lastName ? student.lastName : '') }
                            </p>
                        </div>
                      )}
                      {this.state.isOverflown.status? 
                        <ToolTip 
                        name={this.state.isOverflown.text} 
                        location={{
                          top:this.state.isOverflown.offsetTop, 
                          width:this.state.isOverflown.offsetWidth,
                          height:this.state.isOverflown.offsetHeight
                        }} />: null}
                    </div>
                  </div>
                </div>
              )
            })}
            {this.props.type === 'individual' &&
              _.map(this.alphabetizeSection(this.props.assignmentData), student => {return(
                <div className='panel-section' key={'individual-student-' + this.props.assignmentData.indexOf(student)}>
                  <p className='panel-contents'>{student.firstName + ' ' + (student.lastName ? student.lastName: '') + ' (' + student.sectionName + ')'}</p>
                </div>
              )
            })}
          </div>
        }
      </div>
    )
  }
}

const ToolTip =({name, location})=>{
  // this component is to show the full text that is too long on a tooltip and has been cut off in overflow
  // when the tooltip is cutoff by viewport, tooltip should switch style to be right aligned
  const backgroundColor = '#353C43'
  const classes = {
    container:{
      position:'absolute',
      fontSize:'12px',
      zIndex:'2',
      left:`${location.width + 5}px`,
      top:location.top + location.height,
      display:'flex',
      flexDirection:'column',
    },
    textBox:{
      backgroundColor: backgroundColor,
      color:'white',
      padding:"10px",
      borderRadius:'4px',
      fontFamily:'Noto Sans',
      whiteSpace:'nowrap'
    },
    upArrow:{
      width:'0',
      height:'0',
      borderLeft:'5px solid transparent',
      borderRight:'5px solid transparent',
      borderBottom:`5px solid ${backgroundColor}`,
      marginLeft:'4px',
      marginRight:'4px'
    }
  }

  const rightAlignContainer = {
    ...classes.container,
    alignItems:'end',
    left:'auto',
    right:'20px'
  }

  const [isChangeStyle,setIsChangeStyle] = React.useState(false)
  const elementRef = React.useRef(null)
  const viewPortWidth = window.innerWidth

  React.useEffect(()=>{
    const currentElement = elementRef.current.getBoundingClientRect()
    if(currentElement.right > viewPortWidth){
      setIsChangeStyle(true)
    }
  },[elementRef])

  return (
  <div ref={elementRef} className="student-name-popup" style={isChangeStyle? rightAlignContainer:classes.container}>
    <div className="student-name-popup-arrow" style={classes.upArrow}></div>
    <span className="student-name-popup-textBox" style={classes.textBox}>{name}</span>
  </div>
  )
}

export default AssignmentInfoPanel
